import { cn } from "@/lib/utils";

export const fieldBaseClasses = cn(
  "w-full rounded-lg px-3 text-gray-1200 placeholder:text-gray-900",
  "transition-[border-color,box-shadow,background-color] duration-200 ease-out",
  "focus-visible:outline-none",
  "aria-invalid:bg-red-500/5 aria-invalid:text-red-500 aria-invalid:placeholder:text-red-500/50",
  "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50"
);

export const fieldVariants = {
  default: cn(
    "border border-gray-400 bg-gray-100 hover:border-gray-700 dark:border-gray-400",
    "focus-visible:border-gray-700 dark:focus-visible:border-gray-700",
    "aria-invalid:border-red-500"
  ),
  secondary: cn(
    "bg-preview-bg shadow-custom",
    "focus-visible:shadow-custom-active"
  ),
};

export type FieldVariant = keyof typeof fieldVariants;
